/* TundraLegs cart add — adds the chosen size and opens Horizon's cart drawer
   already populated (no empty-then-item flash).

   Horizon's product form dispatches the cart event BEFORE the /cart/add fetch
   resolves, so a minimal programmatic add flashes an empty drawer for the
   duration of the request. Here we fetch FIRST, then dispatch the cart event
   with its data already resolved, so the drawer opens with the item in place. */

import { CartLinesUpdateEvent } from '@shopify/events';

/* Accepts one variant id, or an array of { id, quantity } lines (the BOGO
   page adds the paid set and the free set together). */
window.tundraAddToCart = async function (variantIdOrItems) {
  const items = (Array.isArray(variantIdOrItems) ? variantIdOrItems : [{ id: variantIdOrItems, quantity: 1 }])
    .map((i) => ({ id: Number(i.id), quantity: Number(i.quantity) || 1 }))
    .filter((i) => i.id > 0);
  if (!items.length) return;
  const itemCount = items.reduce((n, i) => n + i.quantity, 0);

  // Include the cart-drawer section so Horizon can swap in the rendered markup.
  const cartItems = document.querySelector('cart-items-component');
  const sectionId = cartItems && cartItems.dataset.sectionId;

  let addResponse;
  try {
    addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionId,
      }),
    }).then((r) => r.json());
  } catch (e) {
    return;
  }
  if (!addResponse || addResponse.status) return; // e.g. 422 out of stock

  let ajaxCart;
  try {
    ajaxCart = await fetch('/cart.js').then((r) => r.json());
  } catch (e) {
    return;
  }

  // Fetch is done — dispatch the event and resolve its promise immediately so
  // the cart drawer renders the line and opens in the same frame.
  const deferred = CartLinesUpdateEvent.createPromise();
  const event = new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
    promise: deferred.promise,
  });
  document.dispatchEvent(event);
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
    detail: {
      items: ajaxCart.items,
      source: 'tundra-legs',
      itemCount: itemCount,
      sections: addResponse.sections,
      didError: false,
    },
  });

  // The event refreshes the cart lines (from the pre-rendered sections above);
  // open the drawer on the next frame so it appears already populated. Auto-open
  // from a synthetic event is unreliable, so open it explicitly.
  requestAnimationFrame(() => {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  });
};
